import React, { useCallback } from 'react';
import { useProviderHelpers } from './ProviderHelpers';

const Context = React.createContext();

export const RSASettingsTabProvider = ({ children }) => {
    const { data, execute, clearData } = useProviderHelpers();
 
    const listRecords = useCallback(async (props) => {
        await execute({ scope: 'list', url: `FranchiseRSASettings/GetFranchiseRSAPreferences/${props.instanceTypeId}/${props.franchiseId}`, method: 'GET', secure: true });
    }, [execute]);

    const setRSASettingsPreference = useCallback(async (props) => {
        await execute({ scope: 'update', url: `FranchiseRSASettings/SetFranchiseRSAPreference?menuId=${props.menuId}&instanceTypeId=${props.instanceTypeId}&isEnabled=${props.isEnabled}&franchiseId=${props.franchiseId}`, method: 'PUT', payload: props, secure: true });
    }, [execute]);

    const getFranchiseInstanceTypeId = useCallback(async (props) => {
        await execute({ scope: 'franchiseInstanceType', url: `FranchiseRSASettings/GetFranchiseInstanceTypeId/${props.franchiseId}`, method: 'GET', secure: true });
    }, [execute]);

    const value = {
        data, getFranchiseInstanceTypeId, listRecords, clearData, setRSASettingsPreference
    };
 
    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    );
};

export const useRSASettingsTabStore = () => React.useContext(Context);
